import React, { useRef, useCallback } from 'react';

const AnimButton = ({ 
    type, 
    disabled = false, 
    className, 
    style, 
    isAnimation = true, 
    event, 
    children
}) => {
    
    const btnRef = useRef(null);

    const handleBtnClick = useCallback((e) => {
        e.stopPropagation();
        if (isAnimation) {
            btnRef.current.classList.add('is-animating');
            setTimeout(() => {
                btnRef.current.classList.remove('is-animating');
                if (event) {
                    event(e);
                }
            }, 500);
        } else if (event) {
            event(e);
        }
    }, [isAnimation, event]);
    
    return (
        <button 
            ref={btnRef}
            type={type ? type : "button"} 
            className={className} 
            disabled={disabled}
            style={style}
            onClick={handleBtnClick}
        >
            {[...Array(8)].map((_, index) => (
                <span key={index} className='dot'></span>
            ))}
            {children}
        </button>
    );
}

export default AnimButton;